<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <el-card style="margin-bottom: 20px;">
            <template #header>
                <div class="card-header">
                    <span>设备激活补贴</span>
                </div>
            </template>
            <el-table :data="deviceCommissionList" style="width: 100%">
                <el-table-column prop="partner_code" label="商户CODE" />
                <el-table-column prop="model_code" label="产品型号" />
                <el-table-column prop="region" label="区域">
                    <template #default="scope">
                        {{ getRegionName(scope.row.region) }}
                    </template>
                </el-table-column>
                <el-table-column prop="commission_rate" label="补贴" />
            </el-table>
        </el-card>
        <el-card style="margin-bottom: 20px;">
            <template #header>
                <div class="card-header">
                    <span>订单佣金</span>
                </div>
            </template>
            <el-table :data="orderCommissionList" style="width: 100%">
                <el-table-column prop="partner_code" label="商户CODE" />
                <el-table-column prop="model_code" label="产品型号" />
                <el-table-column prop="region" label="区域" />
                <el-table-column prop="commission_rate" label="佣金比例" />
            </el-table>
        </el-card>
        <el-card style="margin-bottom: 20px;">
            <template #header>
                <div class="card-header">
                    <span>设备生产补贴</span>
                </div>
            </template>
            <el-table :data="deviceFactorySubsidyList" style="width: 100%">
                <el-table-column prop="partner_code" label="商户CODE" />
                <el-table-column prop="model_code" label="产品型号" />
                <el-table-column prop="amount_cny" label="补贴" />
            </el-table>
        </el-card>
    </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../../axios/api'
export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const deviceCommissionList = ref([])
        const orderCommissionList = ref([])
        const deviceFactorySubsidyList = ref([])

        console.log('route -->', route)

        const goback = () => {
            router.go(-1)
        }

        // 区域映射
        const regionMap = {
            'AS': '亚洲',
            'EU': '欧洲',
            'AF': '非洲',
            'OC': '大洋洲',
            'NA': '北美洲',
            'AN': '南极洲',
            'SA': '南美洲'
        }

        const getRegionName = (regionCode) => {
            return regionMap[regionCode] || regionCode
        }

        const getSalesPartnerModelDeviceCommissionList = ({ partner_code, model_code }) => {
            return api.SalesPartnerModelDeviceCommissionList({ partner_code, model_code }).then(res => {
                if (res.data.code === 200) {
                    deviceCommissionList.value = res.data.data
                }
            }).catch(err => {
                console.error('获取详情失败:', err)
                ElMessage.error('获取详情失败')
            })
        }

        const getSalesPartnerModelOrderCommissionList = ({ partner_code, model_code }) => {
            return api.SalesPartnerModelOrderCommissionList({ partner_code, model_code }).then(res => {
                if (res.data.code === 200) {
                    orderCommissionList.value = res.data.data
                }
            }).catch(err => {
                console.error('获取详情失败:', err)
                ElMessage.error('获取详情失败')
            })
        }

        const getDeviceFactorySubsidyList = ({ partner_code, model_code }) => {
            return api.SalesPartnerModelDeviceFactorySubsidyList({ partner_code, model_code }).then(res => {
                if (res.data.code === 200) {
                    deviceFactorySubsidyList.value = res.data.data
                }
            }).catch(err => {
                console.error('获取详情失败:', err)
                ElMessage.error('获取详情失败')
            })
        }

        onMounted(() => {
            const partner_code = route.params.partner_code
            const model_code = route.params.model_code
            if (partner_code && model_code) {
                getSalesPartnerModelDeviceCommissionList({ partner_code, model_code })
                getSalesPartnerModelOrderCommissionList({ partner_code, model_code })
                getDeviceFactorySubsidyList({ partner_code, model_code })
            }
        })

        return {
            goback,
            deviceCommissionList,
            orderCommissionList,
            deviceFactorySubsidyList,
            getSalesPartnerModelOrderCommissionList,
            getSalesPartnerModelDeviceCommissionList,
            getDeviceFactorySubsidyList,
            getRegionName
        }
    }
}
</script>